module.exports = __webpack_public_path__ + "static/media/Tram.3909d78f.mp3";